import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'COUNTRY',
  entryPoint: '/countries',
  collectionName: 'countries',
  querySearchListing: [
    ['name'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Country created',
  successMessageUpdate: 'Country updated',
  successMessageDelete: 'Country deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/country/triggers.js